import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Node = _resolveComponent("Node")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['space', { vertical: _ctx.vertical, small: _ctx.small, large: _ctx.large, full: _ctx.full, xlarge: _ctx.xlarge }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (child, ix) => {
      return (_openBlock(), _createElementBlock("div", {
        key: ix,
        class: "child"
      }, [
        _createVNode(_component_Node, { node: child }, null, 8 /* PROPS */, ["node"])
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ], 2 /* CLASS */))
}